import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import { TCard } from '@/services/requests/Recommendation/types/template7';
import { THttpService } from '@/services/HttpService';

import { getVisibleCardsIdByElement } from '@/helpers/HtmlHelper/getVisibleCardsIdByElement';

export interface ICardInteraction {
  event: React.MouseEvent<HTMLAnchorElement>;
  cardId: string;
  Api: THttpService;
  id: string;
  tabName: string;
  cards: TCard[];
  containerRef: React.RefObject<HTMLElement>;
}

export const handleCardInteraction = async ({
  event,
  cardId,
  Api,
  id,
  tabName,
  cards,
  containerRef,
}: ICardInteraction) => {
  event.preventDefault();
  const redirectURL = event.currentTarget.href;

  await dispatchInteraction(Api, 'card-click', {
    recommendationId: id,
    tabName,
    cardId,
    cardPosition: cards.findIndex(item => item.id === cardId) + 1,
    cards: getVisibleCardsIdByElement(
      containerRef.current as HTMLElement,
      'card-click',
    ),
  }).finally(() => {
    window.location.href = redirectURL;
  });

  return true;
};
